import React, { useEffect, useRef, useState } from "react";

export function PaypalButton({ paypal, amount, onCompleted, onError }) {
  const [complete, setComplete] = useState(false);
  const [order, setOrder] = useState();
  const prevOrder = useRef();
  const btnele = useRef();

  useEffect(() => {
    let button;

    if (paypal && amount) {
      button = CreatePaypalButton({
        element: btnele,
        paypal,
        setComplete,
        setOrder,
        onError,
        amount,
      });
    }

    return () => {
      if (button) {
        button.close();
      }
    };
  }, [paypal, amount, onError, btnele]);

  useEffect(() => {
    if (
      order &&
      complete &&
      onCompleted &&
      prevOrder.current?.id !== order.id
    ) {
      const input = {};
      input.amount = order.purchase_units[0].amount.value;
      input.id = order.id;
      input.emailAddress = order.payer.email_address;
      input.payer_id = order.payer.payer_id;
      input.givenName = order.payer.name.given_name;
      input.surname = order.payer.name.surname;
      input.status = order.status;

      onCompleted({ input });
    }
  }, [order, complete, onCompleted]);

  useEffect(() => {
    prevOrder.current = order;
  }, [order]);

  return <div>{!complete && <div ref={btnele}></div>}</div>;
}

function CreatePaypalButton({
  element,
  paypal,
  setComplete,
  setOrder,
  amount,
  onError,
}) {
  const button = paypal.Buttons({
    createOrder: function (_, actions) {
      return actions.order.create({
        purchase_units: [
          {
            amount: {
              value: amount.replace("$", ""),
            },
          },
        ],
      });
    },

    onApprove: function (_, actions) {
      return actions.order.capture().then(function (details) {
        setComplete(true);
        setOrder(details);
      });
    },

    onError: (err) => {
      if (err?.message) {
        onError(err.message);
        console.error("Error from the Paypal", err);
      }
    },
  });

  setTimeout(()=>{
    button.render(element.current);
  });

  return button;
}

export default PaypalButton;
